export const prescription = [
    {
        id: 1,
        date: "05/05/2022",
        medicine: ["Dolo", "Paracetamol"],
        dosage: ["1 Morning, 1 Night", "1 Morning"],
        duration: ["3 Days", "2 Days"],
        conflicting: ["Dolo conflicts with Alerid"],
        doctor: "Dr.Mishra",
    },
    {
        id: 2,
        date: "14/05/2022",
        medicine: ["Combiflam","Crocin"],
        dosage: ["1 Morning, 1 Night","As Per Fever"],
        duration: ["3 Days","2 Days"],
        doctor: "Dr.Strange",
    }, 
    {
        id: 3,
        date: "12/03/2022",
        medicine: ["Alerid", "Jalra"],
        dosage: ["1 Morning, 1 Afternoon, 1 Night", "1 Morning"],
        duration: ["2 Days", "1 Days"],
        conflicting: ["Alerid conflicts with Dolo"],
        doctor: "Dr.Kumar",
    },



];
